<template>
  <div class="textblock w100">
    <span class="desktop" v-html="parseText()"></span>
    <span class="mobile" v-html="parseTextMobile()"></span>
  </div>
</template>

<script>

  export default {
    name: "textblock",
    props: ['value', 'valueMobile'],
    methods: {
      parseText() {
        return this.value.split('\n').join('<br>');
      },
      parseTextMobile() {
        if (!this.valueMobile) return this.parseText();
        return this.valueMobile.split('\n').join('<br>');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .textblock {
    font-weight: 100;
    font-size: 1rem;
    margin-bottom: 1.5rem;
  }

  $min-width: 500px;

  .mobile {
    @media screen and (min-width: 500px) {
      display: none;
    }
  }

  .desktop {
    @media screen and (max-width: 500px) {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/blocks/Textblock.vue